import { Job } from './../../jobs-module/models/job.model';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { icon, latLng, marker, tileLayer } from 'leaflet';
import { JobListingItem } from '../../jobs-module/models/listing.model';
import { EditorText } from '../../shared-module/components/mj-text-editor/mj-text-editor.component';

@Component({
  selector: 'mj-job-description',
  templateUrl: './job-description.component.html',
  styleUrls: ['./job-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobDescriptionComponent implements OnChanges {
  @Input() public job: Job;
  @Input() public listingItem: JobListingItem;

  @Output() public onItemChanged = new EventEmitter<JobListingItem>();
  @Output() public onItemScheduledForRemoval = new EventEmitter<
    JobListingItem
  >();

  isColorPickerOn;
  // Map variables
  options: any = {
    layers: [
      tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: 'Job location',
      }),
    ],
    zoom: 13,
  };
  layers: any[] = [];
  center: any = {};

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      title: '',
      subtitle_rich: '',
      title_rich: '',
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job && this.job) {
      this._setMapView(this.job);
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title !== this.listingItem.title
    ) {
      this.form.patchValue({
        title: this.listingItem.title,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.title_rich !== this.listingItem.title_rich
    ) {
      this.form.patchValue({
        title_rich: this.listingItem.title_rich,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.subtitle_rich !== this.listingItem.subtitle_rich
    ) {
      this.form.patchValue({
        subtitle_rich: this.listingItem.subtitle_rich,
      });
    }
    if (
      changes.listingItem &&
      this.listingItem &&
      this.form.value.image_media_id !== this.listingItem.image_media_id
    ) {
      this.form.patchValue({
        image_media_id: this.listingItem.image_media_id,
        image_url: this.listingItem.image_url,
      });
    }
  }

  saveTitle($event: EditorText) {
    this.form.patchValue({
      title_rich: $event.rich,
      title: $event.plain,
    });
    this._updateValues();
  }

  saveText($event: EditorText) {
    this.form.patchValue({
      subtitle_rich: $event.rich,
    });
    this._updateValues();
  }

  _updateValues() {
    this.onItemChanged.emit({ ...this.listingItem, ...this.form.value });
  }

  // Functions for Map View
  _setMapView(job) {
    this.options = { ...this.options, ...this._setMapOptions(job) };
    this.layers = [...this.layers, ...this._setMapLayers(job)];
    this.center = { ...this.center, ...this._setMapCenter(job) };
  }

  _setMapOptions(job) {
    return {
      center: latLng(job.lat, job.lon),
    };
  }

  _setMapLayers(job) {
    if (!job.lat || !job.lon) {
      return [];
    }
    return [
      marker([job.lat, job.lon], {
        icon: icon({
          iconUrl: 'assets/svgs/map/baseline-place-24px.svg',
          shadowUrl:
            'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png',
        }),
      }),
    ];
  }

  _setMapCenter(job) {
    return { lat: job.lat, lon: job.lon };
  }

  onMapReady(map: any) {
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    if (map.tap) {
      map.tap.disable();
    }
    const mapView = document.getElementById('map');
    if (mapView) {
      mapView.style.cursor = 'default';
    }
  }
}
